import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, TrashIcon, EditIcon, AddIcon, ViewIcon, CheckGreenIcon, CloseIcon, MoneyIcon, DownloadExcelIcon } from 'assets/icons';
import { ReferralService } from 'services';
import moment from 'moment';
import ModalView from './modal-view';
import ModalAmount from './modal-amount';

declare var window: any;

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	status: '',
	since: '',
	until: ''
}

class AdminReferrals extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Usuario',
			'Cantidad de referidos',
			'Fecha de Pago',
			'Monto pagado',
			'Referencia de pago',
			'Estatus pago de bono',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		referral_amounts: [],
		visible_amount: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Referidos',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ReferralService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD')
		});
		this.setState({
			data: res.referrals.rows,
			last_page: res.referrals.count,
			referral_amounts: res.referral_amounts
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	getColor = (status: number) => {
		switch(status) {
			case Constants.REFERRAL_STATUS.PENDING:
				return Colors.yellow;
			break;

			case Constants.REFERRAL_STATUS.FINISH:
				return Colors.danger;
			break;

			case Constants.REFERRAL_STATUS.PAID:
				return Colors.green;
			break;
		}
	}

	onCloseView = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	onCloseAmount = () => {
		this.setState({
			visible_amount: false
		},() => this.load(true));
	}

	openAmount = () => {
		this.setState({
			visible_amount: true
		});
	}

	pay = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Realizar el pago del bono?',async () => {
			await ReferralService.admin.pay({
				referral_id: item?.id
			});
			Globals.showSuccess("Se ha realizado el pago correctamente");
			this.load(true);
		});
	}

	download = async () => {
		const res: any = await ReferralService.admin.download({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD')
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	render() {
		const { visible, visible_amount } = this.state;

		return (
			<div id="admin-referrals">
				<Modal
		          className="modal-referral-view"
		          visible={ visible }
		          title="Ver referidos del club"
		          onClose={ () => this.onCloseView() }
		        >
		          <ModalView
		          	item={ this.state.item }
		          	referral_amounts={ this.state.referral_amounts }
		            onClose={ () => this.onCloseView() } />
		      	</Modal>

		      	<Modal
		          className="modal-referral-amount"
		          visible={ visible_amount }
		          title="Configuración referidos del Club"
		          onClose={ () => this.onCloseAmount() }
		        >
		          <ModalAmount
		          	referral_amounts={ this.state.referral_amounts }
		            onClose={ () => this.onCloseAmount() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12 row">
						<div className="col-md">
							<Input
								value={ this.state.form.search }
								name="search"
								placeholder="Buscar"
								label="Nombre o correo"
								className="input-table"
								onSubmit={ () => this.load() }
								onChange={ (e: any) => {
									clearTimeout(this.timer);
									this.timer = setTimeout(() => {
										this.load(true);
									},1000);
									this.change(e); 
								} } />
						</div>
						<div className="col-md">
							<Select
								placeholder="Seleccionar"
								label="Estatus de Pago de Bono"
								name="status"
								color="white"
								onChange={ (e: any) => this.change(e,async () => {
									this.load(true);
								}) }
								value={ this.state.form.status }
								options={ [
									{ value: Constants.REFERRAL_STATUS.PENDING.toString() , label: 'Pendientes' },
									{ value: Constants.REFERRAL_STATUS.FINISH.toString() , label: 'Por pagar' },
									{ value: Constants.REFERRAL_STATUS.PAID.toString() , label: 'Pagados' }
								] } />
						</div>
						<div className="col-md">
							<DatePicker
								label="Desde"
								placeholder="Desde"
								onChange={ (text: string) => {
									this.change({
										target: {
											value: text,
											name: 'since'
										}
									},() => this.load(true));
								} }
								value={ this.state.form.since }
							/>
						</div>
						<div className="col-md">
							<DatePicker
								label="Hasta"
								placeholder="Hasta"
								onChange={ (text: string) => {
									this.change({
										target: {
											value: text,
											name: 'until'
										}
									},() => this.load(true));
								} }
								value={ this.state.form.until }
							/>
						</div>
						<div className="col-md">
							{
								this.state.form != INITIAL_STATE && (
									<button className="btn btn-clean" onClick={ () => this.reset() }>
										<img src={ CleanIcon } />
									</button>
								)
							}
						</div>
					</div>
				</div>

				{
					checkPermission(Constants.MODULES.REFERRALS,'write') && (
						<button className="btn btn-credolab" onClick={ () => this.openAmount() }>
							Configuración
						</button>
					)
				}

				<Table title="Referidos" data={ this.state.data.length } header={ this.state.header } titleRight={
					<>
						{
							this.state.data.length > 0 && (
								<div className="container-add-table">
									<p>Descargar Excel</p>
									<button className="btn add-btn-table" onClick={ this.download }>
										<img src={ DownloadExcelIcon } />
									</button>
								</div>
							)
						}
					</>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>
									<p className="name"><strong>{ i?.user ? (i?.user?.name + ' ' + i?.user?.lastname) : '-' }</strong></p>
									<p className="email">{ i?.user ? i?.user?.email : '-' }</p>
									<p style={{ whiteSpace: 'nowrap' }}>{ ((i.user?.document_type?.name || '') + ((i.user?.document_type_id == Constants.DOCUMENT_TYPES.PASSPORT || i.user?.document_type_id == Constants.DOCUMENT_TYPES.COLOMBIA) ? ' - ' : '')) + i.user?.document }</p>
								</td>
								<td>{ i.users_count }</td>
								<td>{ i.payment_date ? moment(i.payment_date).format('DD/MM/YYYY') : '-' }</td>
								<td>{ i.status == Constants.REFERRAL_STATUS.PENDING ? '-' : i.status == Constants.REFERRAL_STATUS.FINISH ? '-' : Globals.formatMiles(i.amount) }</td>
								<td>{ i?.reference || '-' }</td>
								<td className="status" style={{
									color: this.getColor(i.status)
								}}>{ i?.status_text || '-' }</td>
								<td style={{ 'whiteSpace': 'nowrap' }}>
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
									{
										i?.status == Constants.REFERRAL_STATUS.FINISH && i.user?.country_id == Constants.COUNTRIES.VZLA && (
											<Tooltip title="Pagar">
												<a className="link-icon link-green" href="#" onClick={ (e: any) => this.pay(e,i) }>
													<img src={ MoneyIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(AdminReferrals);